import request from '../../api/request';
import { CreateTeacherSurveyDto, SurveyResponse } from './types';

/**
 * SURVEYS DRAFT SECTION
 */
const TEACHER_SURVEYS = {
  GET: (sectionId: string, teacherId: string) =>
    `students-portal/student-survey/section/${sectionId}/teacher/${teacherId}`,
  SUBMIT: (sectionId: string, teacherId: string) =>
    `students-portal/student-survey/section/${sectionId}/teacher/${teacherId}/save`,
};
export async function getSurveyData(sectionId: string, teacherId: string) {
  return request<SurveyResponse>(TEACHER_SURVEYS.GET(sectionId, teacherId), {
    method: 'GET',
  });
}

export async function submitSurvey(
  sectionId: string,
  teacherId: string,
  data: CreateTeacherSurveyDto,
) {
  return request<void>(TEACHER_SURVEYS.SUBMIT(sectionId, teacherId), {
    method: 'POST',
    data,
  });
}
